










































































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { isEqual } from "lodash-es";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import useAdminManagedUser from "@/hooks/useAdminManagedUser";
import { isVideoFile } from "@/lib/fileHelpers";
import BaseIcon from "@/components/BaseIcon";
import { ProcessedContentFiles } from "@/components/ContentFeedItem";
import FullScreen from "@/components/FullScreen";
import GalleryTotalItems from "@/components/GalleryTotalItems";
import ContentFeedGalleryItem from "../ContentFeedGalleryItem";
import ContentFeedLocked from "../ContentFeedLocked";

interface FileListInfo {
  accessed: boolean;
  file: ContentFile | null;
  id: string;
}

export default defineComponent({
  name: "ContentFeedGallery",
  components: { FullScreen, ContentFeedLocked, ContentFeedGalleryItem, BaseIcon, GalleryTotalItems },
  props: {
    fileList: { type: Object as () => ProcessedContentFiles, required: true },
    feedId: { type: String, required: true },
  },
  setup(props) {
    const { isAdminManagedUser: allowDownload } = useAdminManagedUser();
    const currentItemSetter = ref<(count: number) => void>();
    const isActive = ref<boolean>(false);
    const currentItemIndex = ref(0);
    const fileClicked = ref<boolean>(false);

    const allFiles = computed(() => props.fileList.all);
    const accessedFiles = computed(() => props.fileList.accessed);
    const lockedFiles = computed(() => props.fileList.locked);
    const listLength = computed(() => accessedFiles.value.length + (lockedFiles.value.length > 0 ? 1 : 0));
    const lockFullScreen = ref<boolean>(false);

    const renderFileList = computed<FileListInfo[]>(() => {
      const lockedFile: FileListInfo[] = [];
      if (lockedFiles.value.length > 0) {
        lockedFile.push({ accessed: false, file: null, id: lockedFiles.value[0].id });
      }
      return accessedFiles.value
        .map(file => ({ accessed: true, file, id: file.id } as FileListInfo))
        .concat(lockedFile);
    });

    const galleryItemStyle = computed(() => {
      const file = accessedFiles.value[0];
      if (file && file.width > 0 && file.height > 0) {
        return {
          "padding-bottom": `${Math.min(Math.ceil((file.height / file.width) * 100), 150)}%`,
        };
      }
      return {};
    });

    const scalable = computed(
      () => accessedFiles.value[currentItemIndex.value] && !isVideoFile(accessedFiles.value[currentItemIndex.value])
    );

    const closeFullScreen = () => {
      fileClicked.value = false;
    };

    const onChangeIndex = (newIndex: number) => {
      currentItemIndex.value = newIndex;
    };

    watch(allFiles, (files: ContentFile[], old: ContentFile[]) => {
      if (isEqual(files, old)) return;
      currentItemSetter.value && currentItemSetter.value(0);
    });

    return {
      accessedFiles,
      lockedFiles,
      galleryItemStyle,
      isActive,
      fileClicked,
      closeFullScreen,
      listLength,
      currentItemSetter,
      scalable,
      onChangeIndex,
      renderFileList,
      lockFullScreen,
      allowDownload,
    };
  },
});
